/**
 * useDeveloperMode — single hook for "is dev mode on for this org?"
 *
 * Backed by `organization.feature_flags.debug_sync_queue` (the original
 * storage key from Wave 10.3). When the platform admin toggles "Developer
 * Mode" ON for an org in /admin-dash, this returns true and ALL diagnostic
 * surfaces become visible to that org's users:
 *
 *   - /sync-queue route + Settings link
 *   - Recovery tools / Push to queue buttons
 *   - JSON Export Diagnostic button
 *   - Raw sync logs
 *   - Field Notes badge "Details" link
 *
 * When OFF: every surface above is hidden / route blocked.
 *
 * Keeping the underlying storage key as `debug_sync_queue` for backward
 * compatibility — orgs already toggled on stay on. The UI now labels it
 * "Developer Mode" everywhere.
 */
import { useAuth } from '@/context/AuthContext';

export const useDeveloperMode = () => {
  const { organization } = useAuth();
  return !!organization?.feature_flags?.debug_sync_queue;
};

export default useDeveloperMode;
